export default "__VITE_ASSET__L8bRAv3L__"